import React from 'react'
import {DateUtils} from 'react-day-picker'
import moment from 'lib/localizedMoment'
import Button from 'components/shared/Button'
import {getUnavailabilityReason} from 'lib/bookingHelpers'
import TimeSlotPicker from 'components/shared/BookingTimeSlotPicker'
import './index.scss'

const ResourceAvailabilityForDates = ({availabilities, reservedBooking, selectedBooking, dates, onSelect, onRemove}) => {
  return (
    <div className="resource-availability-for-dates">
      {dates.map((date, i) => {
        const availabilityOnDate = availabilities.find(a => a.date === date.format('YYYY-MM-DD'))

        const isAvailable = availabilityOnDate.isAvailable
        const unavailabilityReason = !isAvailable && availabilityOnDate.unavailabilityReason

        const isBeingSelected = selectedBooking
          && availabilityOnDate.pendingBookings
          && availabilityOnDate.pendingBookings.find(pb => pb.id === selectedBooking.id)

        const isSelected = reservedBooking
          && availabilityOnDate.pendingBookings
          && availabilityOnDate.pendingBookings.find(pb => pb.id === reservedBooking.id)

        const isInPast = !DateUtils.isFutureDay(date.toDate())

        const classNames = ['day-container', (!isAvailable || isInPast) ? 'unavailable' : 'available']
        if (isSelected) classNames.push('selected')

        return (
          <div key={i} className={classNames.join(' ').trim()}>
            <span className="weekday">{date.format('dddd')}</span>
            <span className="day">{date.format('DD. MMMM')}</span>
            {unavailabilityReason ? (
              <span className="unavailable-reason">
                {getUnavailabilityReason(unavailabilityReason)}
              </span>
            ) : (
              <>
                {isSelected ? (
                  <>
                    <span>{moment(reservedBooking.startsAt).format('HH:mm')}</span>
                    <Button
                      type="primary"
                      danger
                      block
                      onClick={onRemove}
                      loading={isBeingSelected}
                    >
                      Fjern
                    </Button>
                  </>
                ) : (
                  <TimeSlotPicker
                    pendingBookings={availabilityOnDate.pendingBookings}
                    onSelect={onSelect}
                    isBeingSelected={isBeingSelected}
                    disabled={isBeingSelected || isInPast}
                  />
                )}
              </>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default ResourceAvailabilityForDates
